module.exports = __webpack_public_path__ + "static/media/4.หนังสือยินยอมคู่สมรส (ผู้ขอกู้ยืม).6cb67f44.pdf";